import apiClient from '../config/axiosConfig.js';

/**
 * AI auto-tagging client. The wizard checks `getStatus()` to decide whether to
 * show the feature, then calls `suggestFolderTags()` (opt-in) to get per-folder
 * tag suggestions the user reviews and accepts.
 */

/** @returns {Promise<{configured: boolean}>} — pass {skipGlobalErrorToast:true};
 *  a failed capability probe should not toast (it just hides the AI button). */
export async function getStatus(options = {}) {
    const res = await apiClient.get('/api/ai/status', options);
    return res.data || {};
}

/**
 * @param {Array<{key,name,path,childFolderNames,sampleFileNames,fileTypeHistogram}>} folders
 * @returns {Promise<Array<{key,tags:string[],description:string}>>}
 */
export async function suggestFolderTags(folders, options = {}) {
    const res = await apiClient.post('/api/ai/suggest-folder-tags', { folders }, options);
    return res.data?.suggestions ?? [];
}
